import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppHelper } from 'src/app/helpers/app.helper';
import { FileCategory } from 'src/app/pipes/textMessageIcon.pipe';

export interface MediaPreviewData {
  downloadEnabled: boolean;
  mediaUrl: string;
  mediaType: FileCategory; // Image, Video, Audio
  fileName?: string;
}

@Component({
  selector: 'app-media-preview-dialog',
  templateUrl: './media-preview-dialog.component.html',
  styleUrls: ['./media-preview-dialog.component.scss']
})
export class MediaPreviewDialogComponent {
  FileCategory = FileCategory;

  constructor(
    public dialogRef: MatDialogRef<MediaPreviewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MediaPreviewData
  ) {}

  close() {
    this.dialogRef.close();
  }

  downloadMedia() {
    const fileName = this.data.fileName || this.getDefaultFileName();
    AppHelper.downloadFile(this.data.mediaUrl, fileName);
  }

  private getDefaultFileName(): string {
    switch (this.data.mediaType) {
      case FileCategory.Image:
        return 'image';
      case FileCategory.Video:
        return 'video';
      case FileCategory.Audio:
        return 'audio';
      default:
        return 'media';
    }
  }

  getMediaTypeLabel(): string {
    switch (this.data.mediaType) {
      case FileCategory.Image:
        return 'Image';
      case FileCategory.Video:
        return 'Video';
      case FileCategory.Audio:
        return 'Audio';
      default:
        return 'Media';
    }
  }
}
